import * as actionTypes from '../actions/allActionList';

const initialState = {
  educators: [],
  startedFetchingEducators: false,
  doneFetchingEducators: false,
  failedFetchingEducators: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.STARTED_FETCHING_EDUCATORS:
      return {
        ...state,
        startedFetchingEducators: true,
        doneFetchingEducators: false,
        failedFetchingEducators: false,
      };
    case actionTypes.GOTTEN_EDUCATORS_DETAILS:
      return {
        ...state,
        startedFetchingEducators: false,
        doneFetchingEducators: true,
        failedFetchingEducators: false,
        educators: action.educators,
      };
    case actionTypes.FAILED_TO_GET_EDUCATORS:
      return {
        ...state,
        startedFetchingEducators: false,
        doneFetchingEducators: true,
        failedFetchingEducators: true,
      };
    default:
      return state;
  }
};

export default reducer;
